import { useEffect } from 'react';

import { XCircleIcon } from '@heroicons/react/24/outline';

import { useAppDispatch, useAppSelector } from 'src/app/store/hooks';
import { useTripImportRetrieveQuery } from 'src/common/external/bambi-api/bambiApi';
import { FormErrorMessage } from 'src/common/FormErrorMessage';
import { show } from 'src/common/primitives/Toast/toast.slice';

import { setCsvUploadError, setCsvUploadSuccessMessage } from '../trip.slice';

export function CSVImportStatusContent() {
  const dispatch = useAppDispatch();
  const csvUploadSuccessMessage = useAppSelector((state) => {
    return state.trip.csvUploadSuccessMessage;
  });
  const csvUploadError = useAppSelector((state) => state.trip.csvUploadError);
  const uploadJobId = useAppSelector((state) => state.trip.uploadJobId);

  useTripImportRetrieveQuery(
    {
      id: uploadJobId || '',
    },
    {
      skip: !uploadJobId,
      pollingInterval: 2000,
    }
  );

  const clearCsvUploadError = () => {
    dispatch(setCsvUploadError(undefined));
  };

  useEffect(() => {
    if (typeof csvUploadSuccessMessage === 'string') {
      dispatch(
        show({
          title: csvUploadSuccessMessage,
          type: 'success',
        })
      );
      dispatch(setCsvUploadSuccessMessage(null));
    }
  }, [csvUploadSuccessMessage, dispatch]);

  return (
    <>
      {csvUploadError && typeof csvUploadError === 'string' && (
        <FormErrorMessage>
          <div className="flex items-center justify-between">
            <div data-testid="csv-upload-error-message">{csvUploadError}</div>
            <div>
              <XCircleIcon
                onClick={() => clearCsvUploadError()}
                className="h-6 w-6 cursor-pointer"
              />
            </div>
          </div>
        </FormErrorMessage>
      )}

      {csvUploadError &&
        typeof csvUploadError === 'object' &&
        csvUploadError.details && (
          <FormErrorMessage>
            <div className="flex items-center justify-between">
              <div className="flex flex-col">
                <div className="font-bold">{csvUploadError.details}</div>
                {csvUploadError.errors.map((error) => (
                  <div key={error.trip}>
                    <h4 className="font-medium">
                      Errors for trip:{error.trip}
                    </h4>
                    <ul className="list-disc pl-8">
                      {error.errors.map((error) => (
                        <li key={error}>{error}</li>
                      ))}
                    </ul>
                  </div>
                ))}
              </div>
              <div>
                <XCircleIcon
                  onClick={() => clearCsvUploadError()}
                  className="h-6 w-6 cursor-pointer"
                />
              </div>
            </div>
          </FormErrorMessage>
        )}
    </>
  );
}
